interface ICountry {
  name: string,
  iso2: string,
  dialCode: string,
  format: string,
}

export const additionalCountries: ICountry[] = [
  { name: 'Isle of Man', iso2: 'im', dialCode: '44', format: '+.. .... ......' },
  { name: 'Pitcairn Islands', iso2: 'pn', dialCode: '64', format: '+.. .... ....' },
  { name: 'Cocos (Keeling) Islands', iso2: 'cc', dialCode: '61', format: '+.. . .... ....' },
  { name: 'U.S. Outlying Islands', iso2: 'um', dialCode: '1', format: '+. ... ... ....' },
  { name: 'Christmas Island', iso2: 'cx', dialCode: '61', format: '+.. . .... ....' },
  { name: 'Mayotte', iso2: 'yt', dialCode: '262', format: '+... .... ....' },
  { name: 'Western Sahara', iso2: 'eh', dialCode: '212', format: '+... .. ... ....' },
  { name: 'Heard and McDonald Islands', iso2: 'hm', dialCode: '672', format: '+... . .......' },
  { name: 'Svalbard and Jan Mayen', iso2: 'sj', dialCode: '47', format: '+.. ... .. ...' },
  { name: 'French Southern Territories', iso2: 'tf', dialCode: '262', format: '+... .... ....' },
  { name: 'Antarctica', iso2: 'aq', dialCode: '672', format: '+... . .......' },
  { name: 'Guernsey', iso2: 'gg', dialCode: '44', format: '+.. .... ......' },
  { name: 'Åland Islands', iso2: 'ax', dialCode: '358', format: '+... .. ... ....' },
  { name: 'Bouvet Island', iso2: 'bv', dialCode: '47', format: '+.. ... .. ...' },
  { name: 'South Georgia and the South Sandwich Islands', iso2: 'gs', dialCode: '500', format: '+... ......' },
];
